import {Api} from "./api"

export default class ServiceApi extends Api {
    constructor() {
        super("/service");
    }

    async getService(serviceID: number) {
        return await this.call("/get_service", {serviceID})
    }

    async getServices(projectID: number) {
        return await this.call("/list_service", {projectID})
    }

    async addService(serviceName: string, serviceDescription: string, projectID: number) {
        return await this.call("/add_service", {serviceName, serviceDescription, projectID});
    }

    async deleteService(serviceID: number) {
        return await this.call("/delete_service", {serviceID});
    }

    async updateService(serviceID: number, serviceName: string, serviceDescription: string) {
        return await this.call("/update_service", {serviceID, serviceName, serviceDescription});
    }
}